import { render } from "./select-user-type.vue?vue&type=template&id=89fb41b4&scoped=true"
import script from "./select-user-type.vue?vue&type=script&lang=js"
export * from "./select-user-type.vue?vue&type=script&lang=js"

import "./select-user-type.vue?vue&type=style&index=0&id=89fb41b4&lang=scss&scoped=true"

import exportComponent from "/home/node/ks-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89fb41b4"]])

export default __exports__